//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
import "../no/PartLoadStatus.js";
let d=[[],[[["ncomponents"],"GetComponents",{R_:{components:""}},0,0],[["handle"],"GetComponentPartFileName",{R_:{file_name:''}},1,0],[["handle"],"ComponentHasPosition",{R_:{has_position:''}},1,0],[["handle"],"DeleteComponent",{},1,0],[["handle","load_status"],"AddComponent",{R_:{component:"Assemblies.Component"}},1,0],[["handle","load_status"],"AddNgcComponent",{R_:{component:"Assemblies.Component"}},1,0],[[],"Dispose",{},0,0]],[]];
SPLM.PDM.PendingComponentsManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.PendingComponentsManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;